export const REQUEST_STATUS_ERROR_CODES = {
  NO_PRIMARY_DOCUMENTATION: 'NO_PRIMARY_DOCUMENTATION',
} as const;

export type RequestStatusErrorCode =
  (typeof REQUEST_STATUS_ERROR_CODES)[keyof typeof REQUEST_STATUS_ERROR_CODES];
